import {useEffect, useRef, useState} from "react";
import {ReactComponent as Menu} from "assets/image/Layout/Header/ic_menu.svg";
import {ReactComponent as Code} from "assets/image/Layout/Common/ic_script.svg";
import {MENU_TYPE} from "./list";
import Dropdown from "./Dropdown";
import PIDOpener from "./PIDOpener";
import styles from "./index.module.scss";
import CustomTooltip from "components/Common/Tooltip/CustomTooltip";
import ChatBot from "components/GPTChatbot";
import {useIntl} from "react-intl";
import {ReactComponent as GPTChatbotIcon} from "images/ic_chatGPT_off.svg";
import {TwoBtnPopUp, showPopUp} from "components/PopUp";
import {useSelector, useDispatch} from "react-redux";
import {ADMIN_ACCOUNTS} from "utils";
import {loadFromPID} from "store/actions/asset";

export default function Menus({handleObjectPanel, isObjectPanelOpen, isEditMode, isCodeMode, handleCodeMode}) {
  const intl = useIntl();
  const [isFileMenuOpen, setIsFileMenuOpen] = useState(false);
  const [isHelpMenuOpen, setIsHelpMenuOpen] = useState(false);
  const [isBadgeVisible, setIsBadgeVisible] = useState(true);

  const [isGPTBadgeVisible, setIsGPTBadgeVisible] = useState(true);
  const [isGPTOpen, setIsGPTOpen] = useState(false);

  const [messages, setMessages] = useState([
    {
      message: "Hello, I'm Redbrick Support bot! Ask me anything!",
      messageHtml: "<p>Hello, I'm Redbrick Support bot! Ask me anything!</p>",
      sentTime: "just now",
      sender: "ChatGPT",
    },
  ]);
  const [isPIDOpenerOpen, setIsPIDOpenerOpen] = useState(false);

  const dropdownFileRef = useRef(null);
  const dropdownHelpRef = useRef(null);

  const userEmail = useSelector(state => state.userinfo.email);
  const isAdmin = ADMIN_ACCOUNTS.includes(userEmail);

  const dispatch = useDispatch();

  const handleChatMenu = () => {
    setIsGPTOpen(!isGPTOpen);
    isGPTBadgeVisible && setIsGPTBadgeVisible(false);
  };
  const closeChatMenu = () => {
    setIsGPTOpen(false);
  };

  const handleFileMenu = () => {
    setIsFileMenuOpen(!isFileMenuOpen);
  };

  const handlePIDOpener = () => {
    setIsPIDOpenerOpen(!isPIDOpenerOpen);
  };
  const handleOpenPID = pid => {
    dispatch(loadFromPID(pid));
    setIsPIDOpenerOpen(false);
  };

  const handleHelpMenu = () => {
    setIsHelpMenuOpen(!isHelpMenuOpen);
    isBadgeVisible && setIsBadgeVisible(false);
  };

  useEffect(() => {
    const handleOutsideClick = event => {
      if (dropdownFileRef.current && !dropdownFileRef.current.contains(event.target) && isFileMenuOpen) {
        setIsFileMenuOpen(false);
      } else if (dropdownHelpRef.current && !dropdownHelpRef.current.contains(event.target) && isHelpMenuOpen) {
        setIsHelpMenuOpen(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isFileMenuOpen, isHelpMenuOpen]);

  return (
    <div className={styles.menu}>
      {isEditMode && (
        <>
          <div className={styles.menu_container}>
            <CustomTooltip
              description={
                isObjectPanelOpen
                  ? intl.formatMessage({id: "ID_STUDIO_TOOLTIP_OBJECT_PANEL_CLOSE"})
                  : intl.formatMessage({id: "ID_STUDIO_TOOLTIP_OBJECT_PANEL_OPEN"})
              }
              placement={"bottomLeft"}
            >
              <button type="button" onClick={handleObjectPanel}>
                <Menu />
              </button>
            </CustomTooltip>
          </div>
          <div className={styles.btn_container}>
            <CustomTooltip description={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_CODE_MODE_BTN"})} placement={"bottom"}>
              <label className={styles.switch}>
                <input type="checkbox" checked={isCodeMode} onChange={handleCodeMode} />
                <span className={styles.slider}>
                  <span className={styles.slider_circle}>
                    <Code />
                  </span>
                </span>
              </label>
            </CustomTooltip>
            <div className={styles.dropdown} ref={dropdownFileRef}>
              <button type="button" className={styles.dropdown_btn} onClick={handleFileMenu}>
                File
              </button>
              {isFileMenuOpen && <Dropdown menuType={MENU_TYPE.FILE} handleMenu={handleFileMenu} />}
            </div>
            <div className={styles.dropdown} ref={dropdownHelpRef}>
              <button type="button" className={`${styles.dropdown_btn} ${isBadgeVisible && styles.badge_visible}`} onClick={handleHelpMenu}>
                Help
              </button>
              {isHelpMenuOpen && <Dropdown menuType={MENU_TYPE.HELP} handleMenu={handleHelpMenu} />}
            </div>
            <div className={`${styles.chatbot} ${isGPTBadgeVisible && styles.gpt_badge_visible}`}>
              <GPTChatbotIcon onClick={handleChatMenu} />
              {isGPTOpen && <ChatBot messages={messages} setMessages={setMessages} handleClose={closeChatMenu} />}
            </div>
            {isAdmin && (
              <div className={styles.dropdown} ref={dropdownFileRef}>
                <button type="button" className={styles.dropdown_btn} onClick={handlePIDOpener}>
                  open From PID
                </button>
                {isPIDOpenerOpen && <PIDOpener handleClose={handlePIDOpener} handleOpenPID={handleOpenPID} />}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
